import request from "../helpers/request";
import {createRestfulApi} from "@/api/createRestfulApi";

const URL = {
    KNOWLEDGELIST: "knowledge/getKnowledgeList",
    SAVEKNOWLEDGE: "knowledge/saveKnowledge",
    DELETEKNOWLEDGE: "knowledge/deleteKnowledge",
    //   试卷
    GETTESTPAPERLIST: "testQuestion/getTestPaperList",
    TESTPAPERIMPORT: "testQuestion/testPaperImport",
    DELETETESTPAPER: "testQuestion/deleteTestPaper",
    DEPLOY_TEST_PAPER: "testQuestion/deployTestPaper",
    SAVE_TEST_PAPER: "testQuestion/saveTestPaper",
    CREATE_TEST_PAPER: "testQuestion/createTestPaper",
    GET_TEST_PAPER_TEST_REPORT: "testQuestion/getTestPaperTestReport",
    //   试题
    GET_TEST_QUESTION_LIST: "testQuestion/getTestQuestionList",
    GET_CAN_ADD_TEST_QUESTION_LIST: "testQuestion/getCanAddTestQuestionList",
    MOVE_TEST_QUESTION: "testQuestion/moveTestQuestion",
    DELETE_TEST_PAPER_QUESTION: "testQuestion/deleteTestPaperQuestion",
    SAVE_TEST_QUESTION: "testQuestion/saveTestQuestion",
    SAVE_TEST_PAPER_QUESTION: "testQuestion/saveTestPaperQuestion",
    GET_USER_TEST_REPORT: "testQuestion/getUserTestReport",
    GENERATE_QR_CODE: "client/share/generateQRCode",
};

export default {
    getKnowledgeList: createRestfulApi(URL.KNOWLEDGELIST, {
        queryParams: [],
    }),
    saveKnowledge({
                      id,
                      audioSsmlText,
                      description,
                      displayDescription,
                      material,
                      name,
                      speechRate,
                  }) {
        return request(URL.SAVEKNOWLEDGE, "POST", {
            id,
            audioSsmlText,
            description,
            displayDescription,
            material,
            name,
            speechRate,
        });
    },
    deleteKnowledge({id}) {
        return request(URL.DELETEKNOWLEDGE, "POST", {
            id,
        });
    },
    getTestPaperList: createRestfulApi(URL.GETTESTPAPERLIST, {
        queryParams: [],
    }),
    getTestQuestionList: createRestfulApi(URL.GET_TEST_QUESTION_LIST, {
        queryParams: [],
    }),
    getCanAddTestQuestionList: createRestfulApi(URL.GET_CAN_ADD_TEST_QUESTION_LIST, {
        queryParams: [],
    }),
    moveTestQuestion(payload) {
        return request(URL.MOVE_TEST_QUESTION, "POST", payload);
    },
    importTestPaper(payload) {
        return request(URL.TESTPAPERIMPORT, "POST", payload, false, true);
    },
    deleteTestPaper({id}) {
        return request(URL.DELETETESTPAPER, "POST", {id});
    },
    deployTestPaper({id}) {
        return request(URL.DEPLOY_TEST_PAPER, "POST", {id});
    },
    deleteTestPaperQuestion({id, testPaperId}) {
        return request(URL.DELETE_TEST_PAPER_QUESTION, "POST", {id, testPaperId});
    },
    saveTestQuestion(payload) {
        return request(URL.SAVE_TEST_QUESTION, "POST", payload);
    },
    saveTestPaperQuestion(payload) {
        return request(URL.SAVE_TEST_PAPER_QUESTION, "POST", payload);
    },
    saveTestPaper(payload) {
        return request(URL.SAVE_TEST_PAPER, "POST", payload);
    },
    createTestPaper(payload) {
        return request(URL.CREATE_TEST_PAPER, "POST", payload);
    },
    getTestPaperTestReport(payload) {
        return request(URL.GET_TEST_PAPER_TEST_REPORT, "POST", payload);
    },
    getUserTestReport(payload) {
        return request(URL.GET_USER_TEST_REPORT, "POST", payload);
    },
    generateQRCode(payload) {
        return request(URL.GENERATE_QR_CODE, "POST", payload, true);
    },
};
